import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useQuery } from '@tanstack/react-query';
import { useToast } from '@/hooks/useToast';
import { useEffect } from 'react';

export const GET_SUPPLEMENTAL_ASSETS_QUERY_KEY = 'assets.getSupplementalAssets';

export const useGetSupplementalAssets = ({
  assetId,
  assetTenantId,
  page = 1,
  perPage = 20,
  enabled = true,
}: {
  assetId?: string;
  assetTenantId?: string;
  page?: number;
  perPage?: number;
  enabled?: boolean;
}) => {
  const { getTenantId } = useTenants();
  const { showToast } = useToast();
  const tenantId = assetTenantId ?? getTenantId();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: [GET_SUPPLEMENTAL_ASSETS_QUERY_KEY, { assetId, tenantId, page, perPage }],
    queryFn: () => api.assets.getSupplementalAssets(tenantId, assetId ?? '', page, perPage),
    enabled: !!assetId && !!tenantId && enabled,
  });

  useEffect(() => {
    if (error && enabled) {
      showToast({
        message: 'Failed to load supplemental assets',
        type: 'error',
      });
    }
  }, [error, enabled, showToast]);

  return {
    supplementalAssets: data?.data.supplementalAssets,
    pageData: data?.data.pageData,
    isLoading,
    error,
    refetch,
  };
};
